export default function (context, start, color, lineWidth) {
  const handleRadius = 6;

  context.beginPath();
  context.strokeStyle = color;
  context.lineWidth = lineWidth;
  context.arc(start.x, start.y, handleRadius, 0, 2 * Math.PI);
  context.stroke();
}



// WEBPACK FOOTER //
// ./util/drawCircle.js